import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  authenticatedUserDataSetter,
  openNotificationWithIcon,
} from "../../../Helper";
import LogoWhite from "../../../assets/images/newLog/logo1.png";
import { useDispatch, useSelector } from "react-redux";
import { AdminAPIRoutes, SchoolManagerAPIRoutes } from "../../../api/APIRoutes";
import "../../../assets/styles/header.scss";
import Access from "./access";
import ServerSelect from "./ServerSelect";
const axios = require("axios");

const Header = () => {
  let location = useLocation();
  const dispatch = useDispatch();
  const schoolPageData = useSelector((state) => state.schoolPageData);

  const history = useHistory();

  const [userData, setUserData] = useState(false);
  const [show, setShow] = useState("");
  const [expand, setExpand] = useState(false);

  history.listen((location, action) => {
    if (location.pathname.indexOf("school") > -1) {
    } else {
      dispatch({
        type: "handleSchoolPageData",
        value: null,
      });
    }
  });

  const switchBackAsManager = async () => {
    openNotificationWithIcon(
      "info",
      "بازگشت به پنل مدیریت...",
      "لطفا صبر کنید"
    );
    const data = new FormData();
    data.append(
      "callback_token",
      JSON.parse(localStorage.getItem("zibatran-user-data")).callback_token
    );
    await axios
      .post(
        SchoolManagerAPIRoutes.SwitchBackAsManager,
        data,

        {
          headers: {
            AUTHORIZATION: `Bearer ${
              JSON.parse(localStorage.getItem("zibatran-user-data"))
                .access_token
                ? JSON.parse(localStorage.getItem("zibatran-user-data"))
                    .access_token
                : ""
            }`,
          },
        }
      )
      .then(async function (response) {
        if (response.data) {
          openNotificationWithIcon("success", "موفق", "درحال انتقال به پنل");
          await localStorage.removeItem("zibatran-user-data-has-prev");
          await authenticatedUserDataSetter(response.data);
          window.location = "/dashboard/main";
        }
      })
      .catch(function (error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.length > 0
        ) {
          openNotificationWithIcon(
            "error",
            "خطا",
            error.response.data.errors[0]
          );
        }
      });
  };

  const switchBackAsAdmin = async () => {
    openNotificationWithIcon(
      "info",
      "بازگشت به پنل مدیریت...",
      "لطفا صبر کنید"
    );
    const data = new FormData();
    data.append(
      "callback_token",
      JSON.parse(localStorage.getItem("zibatran-user-data")).callback_token
    );
    await axios
      .post(
        AdminAPIRoutes.AdminCallback,
        data,

        {
          headers: {
            AUTHORIZATION: `Bearer ${
              JSON.parse(localStorage.getItem("zibatran-user-data"))
                .access_token
                ? JSON.parse(localStorage.getItem("zibatran-user-data"))
                    .access_token
                : ""
            }`,
          },
        }
      )
      .then(async function (response) {
        if (response.data) {
          openNotificationWithIcon("success", "موفق", "درحال انتقال به پنل");
          await localStorage.removeItem("zibatran-user-data-has-prev-admin");
          await authenticatedUserDataSetter(response.data);
          window.location = "/admin";
        }
      })
      .catch(function (error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.length > 0
        ) {
          openNotificationWithIcon(
            "error",
            "خطا",
            error.response.data.errors[0]
          );
        }
      });
  };

  return (
    <>
      {userData && localStorage.getItem("zibatran-user-data-has-prev") && (
        <div
          onClick={switchBackAsManager}
          style={{
            backgroundColor: "red",
            position: "absolute",
            width: "100%",
            top: 0,
            left: 0,
            zIndex: 99999,
            color: "#FFFFFF",
          }}
          className="rowCenter cursor-pointer p-2"
        >
          <i className="fal fa-exclamation-triangle" style={{ padding: 5 }} />
          {`این پنل متعلق به ${userData.user_data.name} میباشد٬ جهت بازگشت به پنل مدیریتی خود اینجا کلیک کنید`}
          <i className="fal fa-exclamation-triangle" style={{ padding: 5 }} />
        </div>
      )}

      {userData &&
        localStorage.getItem("zibatran-user-data-has-prev-admin") && (
          <div
            onClick={switchBackAsAdmin}
            style={{
              backgroundColor: "red",
              position: "absolute",
              width: "100%",
              top: 0,
              left: 0,
              zIndex: 99999,
              color: "#FFFFFF",
            }}
            className="rowCenter cursor-pointer p-2"
          >
            <i className="fal fa-exclamation-triangle" style={{ padding: 5 }} />
            {`این پنل متعلق به ${userData.user_data.name} میباشد٬ جهت بازگشت به پنل مدیریتی خود اینجا کلیک کنید`}
            <i className="fal fa-exclamation-triangle" style={{ padding: 5 }} />
          </div>
        )}
      <nav className="sticky navbar navbar-expand-lg navbar-light">
        <div className="container-fluid d-flex justify-content-lg-evenly justify-content-between py-2">
          <div className="d-flex align-items-center">
            <a
              className="navbar-brand"
              onClick={() => {
                history.push("/");
              }}
            >
              <img
                alt="logo"
                style={{ width: "65px", height: "40px", objectFit: "contain" }}
                src={LogoWhite}
              />
            </a>
            {/* <form className="d-md-flex d-none">
              <input
                className=" input-header"
                type="search"
                placeholder="چه چیزی می‌خواهید یاد بگیرید؟"
                aria-label="Search"
              />
              <button className="btn btn-outline-success-nav" type="submit">
                <i className="fa-solid fa-magnifying-glass"></i>
              </button>
            </form> */}
          </div>
          <button
            className="navbar-toggler border-0 shadow-none"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i
              className="fa-solid fa-bars nav-bar"
              onClick={() => setShow(show ? "" : "show")}
            ></i>
          </button>
          <div
            className={`collapse navbar-collapse border-0 justify-content-between ${show}`}
            id="navbarNavDropdown"
          >
            <ul className="navbar-nav align-items-lg-center align-items-start ">
              <li className="navitem">
                <a
                  className="nav-link active"
                  id="home"
                  aria-current="page"
                  onClick={() => {
                    history.push("/");
                  }}
                >
                  صفحه‌اصلی
                </a>
              </li>
              {/* <li className="navitem">
                <a
                  className="nav-link nav-link-tab mx-2"
                  onClick={() => {
                    history.push("/event-list");
                  }}
                >
                  رویدادها
                </a>
              </li> */}
              <li className="navitem">
                <a
                  className="nav-link nav-link-tab mx-2"
                  onClick={() => {
                    history.push("/policy");
                  }}
                >
                  قوانین و شرایط
                </a>
              </li>
              <li className="navitem">
                <a
                  className="nav-link nav-link-tab mx-2 mb-2 mb-md-0"
                  onClick={() => {
                    history.push("/about");
                  }}
                >
                  تماس با ما
                </a>
              </li>
              <li className="d-flex m-md-1">
                {schoolPageData ? (
                  <div className="navbar-nav ">
                    <span
                      style={{
                        padding: "0 10px",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      {schoolPageData.name}
                    </span>

                    <img
                      alt=""
                      src={schoolPageData.logo}
                      id="NavBarLogo"
                      style={{
                        width: "30px",
                        height: "30px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ) : (
                  !userData && (
                    <>
                      <div className="action-menu d-flex align-items-center">
                        <span>
                          <a
                            className="login-link-nav mx-md-2 text-decoration-none"
                            onClick={() => {
                              history.push("/auth");
                            }}
                          >
                            ورود
                          </a>
                        </span>
                        <button
                          className="btn-register btn-pannel btnPnnel1"
                          onClick={() => {
                            history.push("/auth");
                          }}
                        >
                          رایگان ثبت نام کنید
                        </button>
                      </div>
                    </>
                  )
                )}
              </li>
            </ul>
            <div className="d-flex mr-3">
              <Access setUserData={setUserData} userData={userData} />
              <div style={{marginRight: '-47px'}}>
                <ServerSelect />
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
export default Header;
